import {
  Typography,
  Box,
  Chip,
  Divider
} from "@mui/material";
import {
  CalendarToday as CalendarIcon
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import { selectUserMenus, selectUserRoleIds, selectUserPermissionIds } from '../store/slices/database/userAccessDataSlice';


export default function SimpleTestPage() {

  const { data: userCompanies, loading, error } = useSelector((state) => state.userCompanies);
  const selectedCompany = useSelector(state => state.selectedCompany.data?.companyData);
  const userPermissionIds = useSelector(selectUserPermissionIds);
  const userMenus = useSelector(selectUserMenus);
  const { currentLanguage } = useSelector(state => state.translations);
  return (
    <Box sx={{ p: 4, maxWidth: 800, mx: 'auto' }}>
      {/* Header */}
      <Typography variant="h3" gutterBottom color="primary">
        Simple Test Page
      </Typography>

      <Typography variant="body1" color="text.secondary" paragraph>
        This is a test page to verify your React app structure is working correctly.
      </Typography>

      <Divider sx={{ my: 3 }} />

      {/* Content Section */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          Components Test
        </Typography>
        <Typography variant="body1">
          Total companies: {userCompanies?.length || 0}
        </Typography>
        <Typography variant="body1">
          Select company: {selectedCompany?.companyId || 0}
        </Typography>
        {/* <Typography variant="body1">
          PermissionIds: {userPermissionIds || 0}
        </Typography> */}
        {/* <Typography variant="body1">
          userMenus: {userMenus || 0}
        </Typography> */}
        <Box sx={{ display: 'flex', gap: 2, my: 2, flexWrap: 'wrap' }}>
          <Chip
            label="Material-UI Working"
            color="success"
            variant="outlined"
          />
          <Chip
            label="Theme Active"
            sx={{
              bgcolor: 'primary.contrastText',
              color: 'primary.main',
            }}
          />
          <Chip
            icon={<CalendarIcon />}
            label="Icons Working"
            color="secondary"
          />

        </Box>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Date Display */}
      <Box
        sx={{
          p: 3,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 2
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <CalendarIcon color="primary" />
          <Typography variant="h6">
            Current Date & Time
          </Typography>
        </Box>

        <Typography variant="body1">
          {new Date().toLocaleDateString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
        </Typography>

        <Typography variant="body2" color="text.secondary">
          {new Date().toLocaleTimeString()}
        </Typography>
      </Box>

      {/* Status Section */}
      <Box sx={{ mt: 4, p: 2, bgcolor: 'success.light', borderRadius: 1 }}>
        <Typography variant="body1" sx={{ color: 'success.dark' }}>
          ✓ All systems operational
        </Typography>
      </Box>
    </Box>
  );
}